import { useState, useEffect } from "react";
import "../../SalesMasterPages/QuotationBuilder/QuotationBuilder.css";
import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import Wrapper from "../../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import GetDate23 from "../../../JsCodes/GetDate";

const QuotationBuilder = () => {
  //----------------------------------------------//
  const baseAPI = process.env.REACT_APP_API_URL;
  //----------------------------------------------//
  const [selectedRows, setSelectedRows] = useState([]);

  // const [leadDetailResponse, setLeadDetailResponse] = useState([]);
  const [quotation, setQuotation] = useState([]);
  const [quotationTotal, setQuotationTotal] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAdditionalInfo, setIsAdditionalInfo] = useState(false);
  const heading = "Estimate";

  const navigate = useNavigate(); // State for the Navigation list
  const location = useLocation();
  if (location.state && location.state.relocation_id != null) {
    localStorage.setItem("relocation_id", location.state.relocation_id);
  }

  // --------------------add data section starts here-------------------

  const [firstItem, setFirstItem] = useState({
    relocation_id: localStorage.getItem("relocation_id"),

    quotation_id: "",
    relocation_date: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    subject: "",
    message: "",
    service_type: "",
    where_did_you_find_us: "",
    referral_url: "",
    owner_name: "",
    place_of_supply: "",
    estimate: "",
    chargeable_wt: "",
    port_of_loading: "",
    port_of_discharge: "",
    cage: "",
    mode_of_transport: "",
    airline_name: "",
    estimate_date: "",
    estimate_expiry_date: "",

  });

  const [leadDetailResponse, setLeadDetailResponse] = useState({
    relocation_id: localStorage.getItem("relocation_id"),
    estimate_id: "",
    estimate: "",
    owner_name: "",
    cage: "",
    estimate_date: "",
    estimate_expiry_date: "",
    place_of_supply: "",
    chargeable_wt: "",
    port_of_loading: "",
    port_of_discharge: "",
    mode_of_transport: "",
    airline_name: "",
    est_created_by: "",
    pet_type: "",
    pet_breed: "",
    job_type: "",
  });

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/QuotationBuilder?relocation_id=${firstItem.relocation_id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setLeadDetailResponse(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching Lead detail:", error);
        });

      axios
        .get(
          `${baseAPI}userget/GetQuotation?relocation_id=${firstItem.relocation_id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setQuotation(response.data.data);
          const initialSelectedRows = response.data.data.map(
            (item) => item.quotation_id
          );
          setSelectedRows(initialSelectedRows);
        })
        .catch((error) => {
          console.error("Error fetching Lead detail:", error);
        });

      getQuotationTotal(firstItem.relocation_id);
    }
  }, []);

  const handleDeleteSelected = async () => {
    const relocation_id = firstItem.relocation_id;
    // Assuming you have a server endpoint for deleting records
    const storedToken = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${baseAPI}UserPost/UpdateQuotation`,
        { relocation_id, selectedRows },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      if (response && response.data) {
        const updatedQuotations = response.data.data;
        setQuotation(updatedQuotations);
        setSelectedRows((prevSelectedRows) =>
          prevSelectedRows.filter((id) =>
            updatedQuotations.some((item) => item.quotation_id === id)
          )
        );

        getQuotationTotal(firstItem.relocation_id);
        setFirstItem((prevItem) => ({
          ...prevItem,
        }));
      }
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function getQuotationTotal(ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}userget/GetQuotationTotal?relocation_id=` + ID, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        //console.log(response.data.data);
        setQuotationTotal(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  function handleChange(e) {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  }

  const handleCheckboxChange = (e, quotationId) => {
    if (e.target.checked) {
      // Checkbox is checked, add the quotationId to the selectedRows
      setSelectedRows((prevSelectedRows) => [...prevSelectedRows, quotationId]);
    } else {
      // Checkbox is unchecked, remove the quotationId from the selectedRows
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter((id) => id !== quotationId)
      );
    }
   
  };

  const handleUpdate = (event) => {
    event.preventDefault();
    handleDeleteSelected();
  };

  function EstimatePage(relocation_id) {
    navigate("/Estimate", { state: { relocation_id: relocation_id } });
  }

  // Css

  const h3Style = {
    background: 'rgb(91, 72, 157)',
    color: 'white',
    fontWeight: 'bold',
    borderRadius: '10px 10px 0 0 ',
    padding: '8px',
  };

  const spanStyle = {
    padding: '8px',
    fontSize: '25px'
  };

  return (
    <div>
      <div className="app-container-QuotationBuilder">
        <MiniDrawer />
        <div className="container-fluid container-QuotationBuilder">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                View Lead Details| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; View Lead Details</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA </option>
                <option value="1">DUBAI </option>
              </select>
            </div>
          </div>
          <Wrapper className="QuotationBuilder">
            {/* ----------------------------------Quotation builder-------------------------------- */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <button
                  style={{ width: "13rem" }}
                  onClick={() => EstimatePage(leadDetailResponse.relocation_id)}
                >
                  {" "}
                  Download Estimate
                </button>
              </div>
              <div style={{ marginTop: "-1rem" }}>
                <button
                  className="btn btn-primary"
                  disabled
                >
                  Clear
                </button>

              </div>
            </div>
          </Wrapper>
          <br />
          {/* ------------------------lead deatil--------------------- */}
          <Wrapper className="QuotationBuilder">
            <h3 style={{ background: 'rgb(91, 72, 157)', color: 'white', fontWeight: 'bold', borderRadius: '10px 10px 0 0', padding: '8px' }}>
              <span style={{ padding: '8px', fontSize: '25px' }}>Bill To</span>
            </h3>
            {/* <h3 style={{h3Style}}><span style={{spanStyle}}>Bill To</span></h3> */}
            <div className="QuotationBuilder-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="QuotationBuilderHeading">
                  <th style={{ width: "25%" }}>
                    <span>Relocation ID</span>
                  </th>
                  <td style={{ width: "25%" }}>
                    <span>{leadDetailResponse.relocation_id}</span>
                  </td>
                  <th style={{ width: "25%" }}>
                    <span>Job Type</span>
                  </th>
                  <td style={{ width: "25%" }}>
                    <span>{leadDetailResponse.job_type}</span>
                  </td>
                </tr>
                <tr className="QuotationBuilderHeading">
                  <th style={{ width: "25%" }}>
                    <span>Owner Name</span>
                  </th>
                  <td style={{ width: "25%" }}>
                    <span>{leadDetailResponse.owner_name}</span>
                  </td>
                  <th style={{ width: "25%" }}>
                    <span>Place Of Supply</span>
                  </th>
                  <td style={{ width: "25%" }}>
                    <span>{leadDetailResponse.place_of_supply}</span>
                  </td>
                </tr>

                <tr className="QuotationBuilderHeading">
                  <th>
                    <span>Estimate</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.estimate}</span>
                  </td>
                  <th>
                    <span>Chargeable Weight in KG</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.chargeable_wt}</span>
                  </td>
                </tr>

                <tr className="QuotationBuilderHeading">
                  <th>
                    <span>Estimate Date</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.estimate_date}</span>
                  </td>
                  <th>
                    <span>Origin City</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.port_of_loading}</span>
                  </td>
                </tr>

                <tr className="QuotationBuilderHeading">
                  <th>
                    <span>Expiry Date</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.estimate_expiry_date}</span>
                  </td>
                  <th>
                    <span>Destination City</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.port_of_discharge}</span>
                  </td>
                </tr>

                <tr className="QuotationBuilderHeading">
                  <th>
                    <span>Cage</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.cage}</span>
                  </td>
                  <th>
                    <span>Mode</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.mode_of_transport}</span>
                  </td>
                </tr>

                <tr className="QuotationBuilderHeading">

                  <th>
                    <span>Pet Type And Breed</span>
                  </th>
                  <td>
                    <span> {leadDetailResponse.pet_type} - {leadDetailResponse.pet_breed} </span>
                  </td>
                  <th>
                    <span>Airline Name</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.airline_name}</span>
                  </td>
                </tr>

                <tr className="QuotationBuilderHeading">
                  <th>

                  </th>
                  <td>

                  </td>
                  <th>
                    <span>Est Created By</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.est_created_by}</span>
                  </td>
                </tr>
              </table>
            </div>
            <br />
          </Wrapper>
          <br />

          <div>
            <Wrapper className="ViewLeadDetails">
              {/* --------------master top button---------start---------- */}
              <div className="container-fluid" styel={{ marginTop: "3rem" }}>
                <div>
                  <h3 style={{ background: 'rgb(91, 72, 157)', color: 'white', fontWeight: 'bold', borderRadius: '10px 10px 0 0', padding: '8px' }}>
                    <span style={{ padding: '8px', fontSize: '25px' }}>{heading}</span></h3>
                  {/* <span style={{ fontSize: "25px" }}>{heading}</span> */}
                </div>
              </div>
              <form className="container-fluid">
                <div className="SalesTarget">
                  <table>
                    <tr className="SalesTargetHeading">
                      <th rowSpan={2}>S No.</th>
                      <th rowSpan={2}>Select</th>
                      <th rowSpan={2}>Item & Description</th>
                      <th rowSpan={2}>HSN/SAC</th>
                      <th rowSpan={2}>Quantity</th>
                      <th rowSpan={2}>Rate</th>
                      <th rowSpan={2}>Taxable Amount</th>
                      <th colSpan={2}>CGST</th>
                      <th colSpan={2}>SGST</th>
                      <th rowSpan={2}>Total</th>
                    </tr>
                    <tr className="SalesTargetHeading">
                      <th>%</th>
                      <th>Amount</th>
                      <th>%</th>
                      <th>Amount</th>
                    </tr>
                    {quotation !== null ? (
                      quotation.map((Lead, index) => (
                        <>
                          <tr key={Lead.customer_id}>
                            <td>{++index}</td>
                            <td>
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  id={Lead.quotation_id}
                                  name={Lead.quotation_id}
                                  value={Lead.quotation_id}
                                  checked={selectedRows.includes(
                                    Lead.quotation_id
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, Lead.quotation_id)
                                  }
                                />
                              </div>
                            </td>
                            <td>{Lead.description}</td>
                            <td>{Lead.hsn_sac}</td>
                            <td>{Lead.quantity}</td>
                            <td>{Lead.rate}</td>
                            <td>{Lead.taxable_amount}</td>
                            <td>{Lead.gst_rate}</td>
                            <td>{Lead.GST}</td>
                            <td></td>
                            <td></td>
                            <td>{Lead.Total}</td>
                          </tr>
                        </>
                      ))
                    ) : (
                      <p>empty</p>
                    )}
                    {quotationTotal !== null ? (
                      quotationTotal.map((Total) => (
                        <>
                          <tr key={Total.customer_id}>
                            <td style={{ textAlign: "right" }} colSpan={5}>
                              {Total.description}
                            </td>
                            <td></td>
                            <td colSpan={2}>{Total.total_taxable_amount}</td>
                            <td colSpan={2}>{Total.total_gst}</td>
                            <td></td>
                            <td>{Total.final_total}</td>
                          </tr>
                        </>
                      ))
                    ) : (
                      <p>empty</p>
                    )}
                  </table>
                </div>
                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={handleUpdate}
                  >
                    Update
                  </button>
                </div>
              </form>
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationBuilder;
